import React, { useEffect, useCallback, useState} from 'react';
import MixBottomPaneOptions from './MixBottomPaneOptions.js';
import EnvelopeOptions from 'components/track/EnvelopeOptions.js';
import ContextualHelpComponent from 'components/sidebar/ContextualHelpComponent.js';
import Keyboard from 'components/midi/Keyboard.js';
import AudioEffects from './AudioEffects.js';
import MidiEffects from './MidiEffects.js';
import Dropdown from 'react-dropdown';
import EffectComponent from 'components/effects/EffectComponent.js';
import Colors from 'components/Colors.js';
import SendEffect from '../../track/SendEffect.js';
import {effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import {connect} from 'react-redux';
import {
    setSelectedSendEffect,
} from 'actions/index.js';
import {EFFECTS} from './constants.js';

const colors = new Colors();

const MixEffects = ({
    sequencerEngine,
    selectedGroup,
    selectedTrack
}) => { 
    const [option, setOption] = useState(EFFECTS);
    let hasTracks = sequencerEngine.tracks.length > 0;
    if (!hasTracks) {
        return (
            <div className="mix-effects-pane"/>
        );
    }

    let _track = sequencerEngine.tracks[selectedTrack];
    let _group = sequencerEngine.groups.groups.find(
        x => x.groupNumber === selectedGroup);


    let color = _track ? colors.getColorForTrack(_track) :
            _group ?
        colors.getColorForTrack(_group.tracks[0]) : 'black';

    let style = {
        backgroundColor: color
    };

    let name = "";
    if (_track) {
        name = _track.presetName || _track.getName();
    } else if (_group) {
        name = "Group " + (_group.groupNumber + 1);
    }

    let innerStyle = {
        // background: "linear-gradient(45deg, " + color + ", #1513a2c2)"
    };
    
    return (
        <div className="mix-effects-pane">
          <div
            style={style}
            className="mix-effects-header">
            <div className="element-name">
              {name}
            </div>
            <MixBottomPaneOptions setOption={setOption} option={option}/>
            {_track ? <EnvelopeOptions track={_track}/> : ''}
          </div>
          <div style={innerStyle} className="mix-effects-inner">
            {selectedGroup !== undefined ? "" : <MidiEffects sequencerEngine={sequencerEngine}/>}
            <AudioEffects sequencerEngine={sequencerEngine}/>
            <ContextualHelpComponent sequencerEngine={sequencerEngine}/>
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
    let selectedTrack = state.mix.selectedGroup === undefined ?
            state.mix.selectedTrack : undefined;
    return {
        selectedGroup: state.mix.selectedGroup,
        selectedTrack, 
        ... state.tracks.groupTracks,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MixEffects);
